import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";

// 施設等新設届参照
// API仕様書_申請情報
import {
  IAPI_APP003_Request,
  IAPI_APP003_Response,
} from "../../../type/apiType";

// 帳票ダウンロードAPI
// API仕様書_共通
import {
  IAPI_COM005_Request,
  IAPI_COM005_Response,
} from "../../../type/apiType";

// 帳票作成状況取得
import {
  IAPI_COM009_Request,
  IAPI_COM009_Response,
} from "../../../type/apiType/index";

// 施設等新設届参照
// API仕様書_申請情報
const httpAPI_APP003 = async (
  param: IAPI_APP003_Request
): Promise<IAPI_APP003_Response> => {
  let res = await http.post(ApiUrl.API_APP003, {
    ...param,
  });
  return res.data;
};

// 帳票ダウンロードAPI
// API仕様書_共通
const httpAPI_COM005 = async (
  param: IAPI_COM005_Request
): Promise<IAPI_COM005_Response> => {
  let res = await http.post(ApiUrl.API_COM005, {
    ...param,
  });
  return res.data;
};

// 帳票作成状況取得API
const httpAPI_COM009 = async (
  param: IAPI_COM009_Request
): Promise<IAPI_COM009_Response> => {
  let res = await http.post(ApiUrl.API_COM009, {
    ...param,
  });

  return res.data;
};

export { httpAPI_APP003, httpAPI_COM005, httpAPI_COM009 };
